import React, { useMemo } from 'react';
import { ReactFlow } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { useTranslation } from 'react-i18next';
import './ThuongMaiOrgChart.scss';

const ThuongMaiOrgChart = () => {
  const { t } = useTranslation();

  const colX1 = 50;
  const colX2 = 350;
  const colX3 = 650;

  const nodes = useMemo(() => [
    { id: 'bod', position: { x: colX2, y: 0 }, data: { label: t('orgChartThuongMai.bod') }, className: 'org-node blue-dark' },
    { id: 'ceo', position: { x: colX2, y: 100 }, data: { label: t('orgChartThuongMai.ceo') }, className: 'org-node blue-mid' },
    { id: 'secretary', position: { x: colX2 + 250, y: 150 }, data: { label: t('orgChartThuongMai.secretary') }, className: 'org-node blue-mid', targetPosition: 'left' },
    { id: 'deputyCeo', position: { x: colX2, y: 200 }, data: { label: t('orgChartThuongMai.deputyCeo') }, className: 'org-node green' },

    // Columns Headers
    { id: 'salesMarketing', position: { x: colX1, y: 320 }, data: { label: t('orgChartThuongMai.salesMarketing') }, className: 'org-node blue-light' },
    { id: 'technical', position: { x: colX2, y: 320 }, data: { label: t('orgChartThuongMai.technical') }, className: 'org-node blue-light' },
    { id: 'support', position: { x: colX3, y: 320 }, data: { label: t('orgChartThuongMai.support') }, className: 'org-node blue-light' },

    // Sales & Marketing Children (Left Aligned)
    { id: 'customerDev', position: { x: colX1 + 40, y: 400 }, data: { label: t('orgChartThuongMai.customerDev') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'projectBiz', position: { x: colX1 + 40, y: 460 }, data: { label: t('orgChartThuongMai.projectBiz') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'distribution', position: { x: colX1 + 40, y: 520 }, data: { label: t('orgChartThuongMai.distribution') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'customerService', position: { x: colX1 + 40, y: 580 }, data: { label: t('orgChartThuongMai.customerService') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'marketingComm', position: { x: colX1 + 40, y: 640 }, data: { label: t('orgChartThuongMai.marketingComm') }, className: 'org-node blue-mid', targetPosition: 'left', sourcePosition: 'left' },

    // Technical Children
    { id: 'projectSupport', position: { x: colX2 + 40, y: 400 }, data: { label: t('orgChartThuongMai.projectSupport') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'techDeployment', position: { x: colX2 + 40, y: 460 }, data: { label: t('orgChartThuongMai.techDeployment') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'techCustomerSupport', position: { x: colX2 + 40, y: 520 }, data: { label: t('orgChartThuongMai.techCustomerSupport') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'rnd', position: { x: colX2 + 40, y: 580 }, data: { label: t('orgChartThuongMai.rnd') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },

    // Support Children
    { id: 'finance', position: { x: colX3 + 40, y: 400 }, data: { label: t('orgChartThuongMai.finance') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'adminHr', position: { x: colX3 + 40, y: 460 }, data: { label: t('orgChartThuongMai.adminHr') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'legal', position: { x: colX3 + 40, y: 520 }, data: { label: t('orgChartThuongMai.legal') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
    { id: 'purchasing', position: { x: colX3 + 40, y: 580 }, data: { label: t('orgChartThuongMai.purchasing') }, className: 'org-node blue-pale', targetPosition: 'left', sourcePosition: 'left' },
  ], [t]);

  const edgeStyle = { stroke: '#23a84f', strokeWidth: 1.5 };
  
  const edges = useMemo(() => [
    { id: 'e1', source: 'bod', target: 'ceo', type: 'straight', style: edgeStyle },
    { id: 'e2', source: 'ceo', target: 'deputyCeo', type: 'straight', style: edgeStyle },
    { id: 'e3', source: 'ceo', target: 'secretary', type: 'step', style: edgeStyle },
    
    // Deputy to Columns
    { id: 'e4', source: 'deputyCeo', target: 'salesMarketing', type: 'step', style: edgeStyle },
    { id: 'e5', source: 'deputyCeo', target: 'technical', type: 'step', style: edgeStyle },
    { id: 'e6', source: 'deputyCeo', target: 'support', type: 'step', style: edgeStyle },

    // Column 1
    { id: 'e7', source: 'salesMarketing', target: 'customerDev', type: 'step', style: edgeStyle },
    { id: 'e8', source: 'customerDev', target: 'projectBiz', type: 'step', style: edgeStyle },
    { id: 'e9', source: 'projectBiz', target: 'distribution', type: 'step', style: edgeStyle },
    { id: 'e10', source: 'distribution', target: 'customerService', type: 'step', style: edgeStyle },
    { id: 'e11', source: 'customerService', target: 'marketingComm', type: 'step', style: edgeStyle },

    // Column 2
    { id: 'e12', source: 'technical', target: 'projectSupport', type: 'step', style: edgeStyle },
    { id: 'e13', source: 'projectSupport', target: 'techDeployment', type: 'step', style: edgeStyle },
    { id: 'e14', source: 'techDeployment', target: 'techCustomerSupport', type: 'step', style: edgeStyle },
    { id: 'e15', source: 'techCustomerSupport', target: 'rnd', type: 'step', style: edgeStyle },

    // Column 3
    { id: 'e16', source: 'support', target: 'finance', type: 'step', style: edgeStyle },
    { id: 'e17', source: 'finance', target: 'adminHr', type: 'step', style: edgeStyle },
    { id: 'e18', source: 'adminHr', target: 'legal', type: 'step', style: edgeStyle },
    { id: 'e19', source: 'legal', target: 'purchasing', type: 'step', style: edgeStyle },
  ], []);

  return (
    <div className="thuongmai-orgchart-page">
      <div className="thuongmai-orgchart-container">
        <div className="vertical-label left-label">
          <span className="arrow-down"></span>
          {t('orgChartThuongMai.labelLeft')}
        </div>
        
        <div className="reactflow-wrapper">
          <ReactFlow
            nodes={nodes}
            edges={edges}
            fitView
            fitViewOptions={{ padding: 0.1, minZoom: 0.1 }}
            attributionPosition="bottom-right"
            nodesDraggable={false}
            nodesConnectable={false}
            elementsSelectable={false}
            zoomOnScroll={false}
            panOnDrag={true}
            zoomOnPinch={true}
          />
        </div>

        <div className="vertical-label right-label">
          {t('orgChartThuongMai.labelRight')}
          <span className="arrow-up"></span>
        </div>

        <div className="horizontal-label bottom-label">
          <span className="arrow-left"></span>
          {t('orgChartThuongMai.labelBottom')}
          <span className="arrow-right"></span>
        </div>
      </div>

      <div className="orgchart-bento-container">
        {/* KHỐI KINH DOANH */}
        <div className="bento-division">
          <div className="bento-header">
            <h3>{t('orgChartThuongMai.table.businessDiv')}</h3>
          </div>
          <div className="bento-grid">
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.managementBoard')}</h4>
              {t('orgChartThuongMai.table.managementBoardDesc') && <p>{t('orgChartThuongMai.table.managementBoardDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.customerDev')}</h4>
              {t('orgChartThuongMai.table.customerDevDesc') && <p>{t('orgChartThuongMai.table.customerDevDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.retail')}</h4>
              {t('orgChartThuongMai.table.retailDesc') && <p>{t('orgChartThuongMai.table.retailDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.project')}</h4>
              {t('orgChartThuongMai.table.projectDesc') && <p>{t('orgChartThuongMai.table.projectDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.management')}</h4>
              {t('orgChartThuongMai.table.managementDesc') && <p>{t('orgChartThuongMai.table.managementDesc')}</p>}
            </div>
          </div>
        </div>

        {/* KHỐI KỸ THUẬT */}
        <div className="bento-division">
          <div className="bento-header">
            <h3>{t('orgChartThuongMai.table.techDiv')}</h3>
          </div>
          <div className="bento-grid">
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.projectSupport')}</h4>
              {t('orgChartThuongMai.table.projectSupportDesc') && <p>{t('orgChartThuongMai.table.projectSupportDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.techSolutions')}</h4>
              {t('orgChartThuongMai.table.techSolutionsDesc') && <p>{t('orgChartThuongMai.table.techSolutionsDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.systemSolutions')}</h4>
              {t('orgChartThuongMai.table.systemSolutionsDesc') && <p>{t('orgChartThuongMai.table.systemSolutionsDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.services')}</h4>
              {t('orgChartThuongMai.table.servicesDesc') && <p>{t('orgChartThuongMai.table.servicesDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.rndTraining')}</h4>
              {t('orgChartThuongMai.table.rndTrainingDesc') && <p>{t('orgChartThuongMai.table.rndTrainingDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.supervision')}</h4>
              {t('orgChartThuongMai.table.supervisionDesc') && <p>{t('orgChartThuongMai.table.supervisionDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.management')}</h4>
              {t('orgChartThuongMai.table.managementDesc') && <p>{t('orgChartThuongMai.table.managementDesc')}</p>}
            </div>
          </div>
        </div>

        {/* KHỐI HỖ TRỢ */}
        <div className="bento-division">
          <div className="bento-header">
            <h3>{t('orgChartThuongMai.table.supportDiv')}</h3>
          </div>
          <div className="bento-grid">
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.financeHr')}</h4>
              {t('orgChartThuongMai.table.financeHrDesc') && <p>{t('orgChartThuongMai.table.financeHrDesc')}</p>}
            </div>
            <div className="bento-card">
              <h4>{t('orgChartThuongMai.table.administration')}</h4>
              {t('orgChartThuongMai.table.administrationDesc') && <p>{t('orgChartThuongMai.table.administrationDesc')}</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThuongMaiOrgChart;
